import React, { useCallback, useEffect, useState } from "react";
import MediaQuery from "react-responsive";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Spreadsheet, MobileSpreadsheet } from "../Spreadsheet/Spreadsheet";
import {
  DOCS_UPDATE,
  fetchDocs,
  selectDocs,
  signDocs,
} from "../../actions/ite";
import { DOCS_RESET } from "../../actions/docs";
import styles from "../../styles/Docs/Docs.module.css";
import { SignPopup } from "../Popup/SignPopup";
import DocsToolbar from "../Docs/DocsToolbar";
import DocsToolbarDevice from "../Docs/DocsToolbarDevice";
import { SIGN_RESET } from "../../actions/sign";
import { DIIA_RESET, signDocs as diiaSign } from "../../actions/diia";
import { DiiaSignPopup } from "../Popup/DiiaSignPopup";
import { FileSignPopup } from "../Popup/FileSignPopup";

//import { docsFilter } from "../../actions/filter";

export default function Docs() {
  const dispatch = useAppDispatch();
  const docs = useAppSelector((state) => state.ite.docs);
  const diia = useAppSelector((state) => state.diia);
  const sign = useAppSelector((state) => state.sign);
  const [showPopup, setShowPopup] = useState(false);
  const [showFilePopup, setShowFilePopup] = useState(false);
  const [showDiiaPopup, setShowDiiaPopup] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [signMethods, setSignMethods] = useState({});
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchParams] = useSearchParams();
  const [multiSelect, setMultiSelect] = useState({
    isSelected: false,
    range: [],
  });
  const token = searchParams.get("token");
  const filter = useAppSelector((state) => state.filter);

  const docsUpdate = () => {
    dispatch({ type: DOCS_RESET });
    setMultiSelect({ isSelected: false, range: [] });
    dispatch(fetchDocs(token));
  };

  const checkSignedDocs = docs.list.reduce((memo, el) => memo || (
    selectedDocs.includes(el.id) && (
    el.signatures.length > 0 ||
    el.error?.code === 115
    )
  ), false);

  const setScroll = (e) => {
    setScrollPosition(e.target?.scrollTop);
  };

  const toggleCheckbox = useCallback(
    (id, isSelected, index, shiftKey) => {
      if (
        shiftKey &&
        (multiSelect.isSelected === isSelected ||
          (index >= Math.min(...multiSelect.range) &&
            index < Math.max(...multiSelect.range)))
      ) {
        setMultiSelect({
          isSelected: multiSelect.isSelected,
          range: [...multiSelect.range, index],
        });
      } else {
        setMultiSelect({ isSelected, range: [index] });
      }
      dispatch(selectDocs([id], isSelected));
    },
    [multiSelect],
  );

  const toggleAll = useCallback((isSelected) => {
    setMultiSelect({ isSelected: false, range: [] });
    dispatch(
      selectDocs(
        docs.list.filter((el) => !el.cancelled).map((el) => el.id),
        isSelected,
      ),
    );
  });

  const closePopup = useCallback(() => {
    setShowPopup(false);
  });

  const closeFilePopup = useCallback(() => {
    setShowFilePopup(false);
  });

  const closeDiiaPopup = useCallback(() => {
    dispatch({ type: DIIA_RESET });
    setShowDiiaPopup(false);
  });

  const clickSignButton = useCallback(
    (e) => {
      e.preventDefault();
        dispatch({ type: SIGN_RESET });
      setShowPopup(true);
    },
    [selectedDocs],
  );

  const clickDiiaSignButton = useCallback(
    (e) => {
      e.preventDefault();
        dispatch({ type: SIGN_RESET });
      dispatch(diiaSign(selectedDocs, "ite", token));
      setShowDiiaPopup(true);
    },
    [selectedDocs, token],
  );

  const clickFileSignButton = useCallback(
    (e) => {
      e.preventDefault();
        dispatch({ type: SIGN_RESET });
      setShowFilePopup(true);
    },
    [selectedDocs],
  );

  const submitForm = useCallback(
    (key) => {
      dispatch(signDocs(selectedDocs, key, token, false));
    },
    [selectedDocs, token],
  );

  useEffect(() => {
    const methods = {};
    const selected = [];
    let unsigned = false;

    docs.list?.forEach((el) => {
      if (docs.selected[el.id] && !el.cancelled) {
        selected.push(el.id);
        if (!el.signed) {
          const docMethds = el.methods.reduce((memo, method) => {
            memo[method.alias] = true; //alias замість id
            return memo;
          }, {});
          if (unsigned) {
            Object.keys(methods).forEach((key) => {
              if (!docMethds[key]) {
                delete methods[key];
              }
            });
          } else {
            Object.assign(methods, docMethds);
            unsigned = true;
          }
        }
      }
    });
    setSelectedDocs(selected);
    setSignMethods(methods);
  }, [docs.selected]);

  useEffect(() => {
      dispatch(fetchDocs(token));
  }, [token]);

  useEffect(() => {
    if ( sign.state === "success") {
      dispatch(selectDocs(selectedDocs, false));
      dispatch({ type: SIGN_RESET });
      dispatch({
        type: DOCS_UPDATE,
        payload: sign.list.reduce((memo, el) => {
            memo[el.id] = el;
            return memo;
          }, {}),
      });
      setShowFilePopup(false);
      setShowPopup(false);
      closeDiiaPopup();
    }
  }, [sign, selectedDocs]);

  useEffect(() => {
    if (multiSelect.range.length > 1) {
      const start = Math.min(multiSelect.range[0], multiSelect.range[1]);
      const end = Math.max(multiSelect.range[0], multiSelect.range[1]) + 1;
      const slice = docs.list
        ?.slice(start, end)
        .filter((el) => !el.cancelled)
        .map((doc) => doc.id);

      if (multiSelect.range.length > 2) {
        // if (multiSelect.range[0] < multiSelect.range[1]) {
        //   if (multiSelect.range[1] > multiSelect.range[2]) {
        //     const slice2 = docs.list?.slice(multiSelect.range[2], multiSelect.range[1] + 1).filter((el) => !el.cancelled).map((doc) => doc.id);
        //     dispatch(selectDocs(slice2, !multiSelect.isSelected));
        //   }
        // } else {
        //   if (multiSelect.range[1] < multiSelect.range[2]) {
        //     const slice3 = docs.list?.slice(multiSelect.range[1], multiSelect.range[2] + 1).filter((el) => !el.cancelled).map((doc) => doc.id);
        //     dispatch(selectDocs(slice3, !multiSelect.isSelected));
        //   }
        // }
        setMultiSelect({
          ...multiSelect,
          range: [multiSelect.range[0], multiSelect.range[2]],
        });
      } else {
        dispatch(selectDocs(slice, multiSelect.isSelected));
      }
    }
  }, [multiSelect]);

  return (
    <>
      <MediaQuery maxWidth={767}>
        <section className={`${styles.wrapper} ${styles.mobile} `}>
          <DocsToolbar
            docsUpdate={docsUpdate}
            selectedDocs={selectedDocs}
            docs={docs}
            toggleAll={toggleAll}
            type="ite"
            token={token}
      />
          <MobileSpreadsheet
            docsUpdate={docsUpdate}
            filter={filter}
            toggleCheckbox={toggleCheckbox}
            docs={docs}
            link={`/sys/documents/{id}/view?token=${token}`}
            scrollPosition={scrollPosition}
            setScrollPosition={setScroll}
            heightTable={ selectedDocs.length > 0 && Object.keys(signMethods).length > 0 }
          />
          {selectedDocs.length > 0 && Object.keys(signMethods).length > 0 && (
            <DocsToolbarDevice
              docsUpdate={docsUpdate}
              selectedDocs={selectedDocs}
              clickSignButton={
                signMethods.gryada && !checkSignedDocs ? clickSignButton : null
              }
              clickDiiaSignButton={
                signMethods.diia && !checkSignedDocs
                  ? clickDiiaSignButton
                  : null
              }
              clickFileSignButton={
                signMethods.file && !checkSignedDocs
                  ? clickFileSignButton
                  : null
              }
              signMethods={signMethods}
            />
          )}
        </section>
      </MediaQuery>

      <MediaQuery minWidth={768}>
        <section className={styles.wrapperIte}>
            <div className={styles.container}>
              <DocsToolbar
                docsUpdate={docsUpdate}
                type="ite"
                token={token}
                selectedDocs={selectedDocs}
                clickSignButton={
                  signMethods.gryada && !checkSignedDocs
                    ? clickSignButton
                    : null
                }
                clickDiiaSignButton={
                  signMethods.diia && !checkSignedDocs
                    ? clickDiiaSignButton
                    : null
                }
                clickFileSignButton={
                  signMethods.file && !checkSignedDocs
                    ? clickFileSignButton
                    : null
                }
                signMethods={signMethods}
              />
            </div>
            <Spreadsheet
              filter={filter}
              toggleAll={toggleAll}
              toggleCheckbox={toggleCheckbox}
              docs={docs}
              link={`/sys/documents/{id}/view?token=${token}`}
              scrollPosition={scrollPosition}
              setScrollPosition={setScroll}
            />
        </section>
      </MediaQuery>

      {showPopup ? (
        <SignPopup
          clickCloseButton={closePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
      {showDiiaPopup ? (
        <DiiaSignPopup clickCloseButton={closeDiiaPopup} diia={diia} />
      ) : null}
      {showFilePopup ? (
        <FileSignPopup
          clickCloseButton={closeFilePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
    </>
  );
}
